<template>
  <div>
    <div class="banner555">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082611212949.jpg"></el-image>
      <div class="cover">
        <h1>联系我们</h1>
      </div>
    </div>
    <div class="box clearfix">
      <el-row :gutter="20">
        <el-col :span="7">
          <div class="contact">
            <div class="title">CONTACT US</div>
            <div class="info">联系我们</div>
            <div class="bd">
              <div class="item">
                <i class="el-icon-phone-outline"></i>
                <span>客服电话：{{ cs_tel }}</span>
              </div>
              <div class="item">
                <i class="el-icon-message"></i>
                <span>橡胶邮箱：{{ rubber_email }}</span>
              </div>
              <div class="item">
                <i class="el-icon-message"></i>
                <span>手套邮箱：{{ glove_email }}</span>
              </div>
              <div class="item">
                <i class="el-icon-location-outline"></i>
                <span>公司地址：{{ address }}</span>
              </div>
              <div class="item">
                <i class="el-icon-message"></i>
                <span>邮箱：{{ email }}</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="17">
          <h3>留言板</h3>
          <el-form class="form-container"
                   ref="form"
                   :model="form"
                   :rules="rules">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item prop="name">
                  <el-input v-model="form.name" placeholder="姓名*"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="email">
                  <el-input v-model="form.email" placeholder="邮箱地址*"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="mobile">
                  <el-input v-model="form.mobile" placeholder="电话*"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item prop="title">
                  <el-input v-model="form.title" placeholder="标题*"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item prop="content">
                  <el-input type="textarea" v-model="form.content" :rows="3" placeholder="内容*"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="btn">
                  <el-button type="success" @click="add">提交</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div class="qrcode clearfix">
      <div class="item">
        <el-image src="/img/st.jpg"></el-image>
        <div class="name">诗董手套公众号</div>
      </div>
      <div class="item">
        <el-image src="/img/xj.jpg"></el-image>
        <div class="name">诗董橡胶公众号</div>
      </div>
    </div>
  </div>
</template>
<script>
import {addContactus, getContactusIndex} from '@/api/api'

export default {
  name: "Index",
  data() {
    return {
      email: null,
      address: null,
      glove_email: null,
      rubber_email: null,
      cs_tel: null,
      form: {
        name: "",
        email: "",
        mobile: "",
        title: "",
        content: "",
        status: "100",
        remark: "",
      },
      rules: {
        name: [{required: true, message: "请输入姓名", trigger: "blur"}],
        email: [{required: true, message: "请输入邮箱地址", trigger: "blur"}],
        mobile: [{required: true, message: "请输入电话", trigger: "blur"}],
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        content: [{required: true, message: "请输入内容", trigger: "blur"}],
      },
    }
  },
  created() {
    this.getIndex();
  },
  methods: {
    getIndex() {
      getContactusIndex().then((res) => {
        this.email = res.data.email;
        this.address = res.data.address;
        this.glove_email = res.data.glove_email;
        this.rubber_email = res.data.rubber_email;
        this.cs_tel = res.data.cs_tel;
      });
    },
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          addContactus(this.form).then((res) => {
            console.log(res)
            this.$notify({
              title: '成功',
              message: '留言成功',
              type: 'success'
            });
            this.$refs['form'].resetFields();
          }).catch((msg) => {
            console.log(msg)
            this.$notify.error({
              title: '错误',
              message: '留言失败'
            });
            this.$refs['form'].resetFields();
          });
        }
      });
    }
  }
}
</script>

<style scoped>
@import url("Index.css");
</style>